import { Column, ColumnAlignment, ColumnType } from "../../types/table";
import { UserView, UserViewType } from "../../types/user";

export const defaultColumns: { [key: string]: Column[] } = {
  [UserViewType.Opportunity]: [
    { id: 'Amount', name: 'Amount(TCV)', align: ColumnAlignment.Left, columnType: ColumnType.Currency },
    { id: 'StageName', name: 'Stage', columnType: ColumnType.String },
    { id: 'CloseDate', name: 'Expected Close Date', columnType: ColumnType.Date },
  ],
  [UserViewType.Customer]: [
    { id: 'Industry', name: 'Industry', columnType: ColumnType.String },
    { id: 'AnnualRevenue', name: 'Revenue', columnType: ColumnType.Number },
    { id: 'NumberOfEmployees', name: 'Company Size', columnType: ColumnType.Number },
    { id: 'Open_Opportunity_Count__c', name: 'Open Opps', columnType: ColumnType.Number },
    { id: 'LastModifiedDate', name: 'Last Activity', columnType: ColumnType.Date },
  ],
  [UserViewType.CustomerTree]: [
  ]
}

export const fixedColumns: { [key: string]: string[] } = {
  [UserViewType.Opportunity]: ['SE Status', 'Opportunity'],
  [UserViewType.Customer]: ['Customer'],
  [UserViewType.CustomerTree]: ['Account Name'],
};

export const permissionColumnMap: { [key: string]: string } = {
  [UserViewType.Opportunity]: 'Opportunity',
  [UserViewType.Customer]: 'Account',
  [UserViewType.CustomerTree]: 'Account',
};

export const defaultViews: { [key: string]: UserView } = {
  [UserViewType.Opportunity]: {
    id: Date.now(),
    name: 'Default Opportunity View',
    type: UserViewType.Opportunity,
    columns: defaultColumns.opportunity,
    filters: [],
  },
  [UserViewType.Customer]: {
    id: Date.now(),
    name: 'Default Customer View',
    type: UserViewType.Customer,
    columns: defaultColumns.customer,
    filters: [],
  },
  [UserViewType.CustomerTree]: {
    id: 3,
    name: 'Default Customer Tree View',
    type: UserViewType.CustomerTree,
    columns: defaultColumns[UserViewType.CustomerTree],
    filters: [],
  },
};

export const defaultOrderBy: { [key: string]: { column: string, order: "asc" | "desc" } } = {
  [UserViewType.Opportunity]: { column: "Name", order: "asc" },
  [UserViewType.Customer]: { column: "Name", order: "asc" },
  [UserViewType.CustomerTree]: { column: "Name", order: "asc" },
}

export const PHASE_COLOURS = {
  '0': 'bg-danger-darker',
  '1': 'bg-[rgb(168,40,40)]',
  '2': 'bg-[rgb(134,69,79)]',
  '3': 'bg-[rgb(101,99,118)]',
  '4': 'bg-[rgb(67,129,157)]',
  '5': 'bg-[rgb(34,158,196)]',
  '6': 'bg-pri-sky',
}